var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNounPpt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#f4b400",
    width: "700pt",
    height: "700pt",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m446.43 161.79-4.0352-111.39h-290.25v461.05h396.65v-348.38zm-148.29 137.7c-2.2539 4.8359-5.5859 9.0898-9.7461 12.434-4.4375 3.3789-9.5 5.8516-14.895 7.2773-5.7617 1.6016-11.719 2.3906-17.695 2.3516h-9.3516c-2.9102 0-5.2656 2.3594-5.2656 5.2656v29.344c0 2.8867-2.3203 5.2344-5.207 5.2656h-16.016c-2.9062 0-5.2656-2.3594-5.2656-5.2656v-107.18c0-2.9062 2.3594-5.2656 5.2656-5.2656h35.113-0.003906c6.1406-0.046876 12.262 0.58984 18.258 1.9062 5.3984 1.0938 10.523 3.2656 15.062 6.3828 4.2734 2.9961 7.7227 7.0234 10.027 11.703 2.625 5.6211 3.8906 11.777 3.6953 17.977 0.042968 6.1602-1.3164 12.25-3.9766 17.809zm100.3 0c-2.3164 4.875-5.75 9.1367-10.027 12.434-4.3555 3.3438-9.3164 5.8164-14.613 7.2773-5.7422 1.5977-11.68 2.3906-17.641 2.3516h-9.3516c-2.9062 0-5.2656 2.3594-5.2656 5.2656v29.344c0 1.3945-0.55469 2.7344-1.5391 3.7227-0.98828 0.98828-2.3281 1.543-3.7227 1.543h-16.016c-2.9102 0-5.2656-2.3594-5.2656-5.2656v-107.18c0-2.9062 2.3555-5.2656 5.2656-5.2656h35.336c6.1172-0.046876 12.223 0.58984 18.199 1.9062 5.2422 1.1523 10.207 3.3203 14.613 6.3828 4.2891 2.9805 7.7422 7.0078 10.027 11.703 2.625 5.6211 3.8906 11.777 3.6953 17.977 0.13281 6.1406-1.1328 12.23-3.6953 17.809zm96.266-38.641h-0.003906c0 1.3945-0.55469 2.7344-1.5391 3.7227-0.98828 0.98828-2.3281 1.543-3.7227 1.543h-21.84c-2.8867 0-5.2344 2.3203-5.2656 5.207v84.785c0 2.8828-2.3242 5.2305-5.207 5.2617h-16.242c-2.9062 0-5.2617-2.3555-5.2617-5.2617v-84.785c0-2.875-2.332-5.207-5.2109-5.207h-21.727c-2.9062 0-5.2617-2.3594-5.2617-5.2656v-11.871c0-2.9062 2.3555-5.2656 5.2617-5.2656h80.754c2.9062 0 5.2617 2.3594 5.2617 5.2656z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m370.38 268.8c-5.1094-2.8711-10.949-4.1953-16.797-3.8086h-6.7773c-2.9062 0-5.2656 2.3555-5.2656 5.2656v24.863c0 2.9062 2.3594 5.2617 5.2656 5.2617h7.7266c14.41 0 21.617-6.2539 21.617-18.762v0.003906c0.46094-4.9922-1.7266-9.8594-5.7695-12.824z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m270.09 268.8c-5.1172-2.8672-10.953-4.1875-16.801-3.8086h-6.832c-2.9102 0-5.2656 2.3555-5.2656 5.2656v24.863c0 2.9062 2.3555 5.2617 5.2656 5.2617h7.7266c14.449 0 21.672-6.2539 21.672-18.762v0.003906c0.46094-4.9922-1.7266-9.8594-5.7656-12.824z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m557.2 141.9-90.047-98.504c-8.9492-9.8047-21.613-15.395-34.887-15.398h-254.58c-12.531 0.015625-24.543 5-33.402 13.859-8.8633 8.8594-13.848 20.875-13.859 33.406v409.47c0.011719 12.531 4.9961 24.547 13.859 33.406 8.8594 8.8594 20.871 13.844 33.402 13.859h344.62c12.531-0.015625 24.543-5 33.402-13.859 8.8633-8.8594 13.848-20.875 13.859-33.406v-311.13c-0.023438-11.742-4.4375-23.047-12.375-31.699zm-29.848 14.055-58.016 0.003907c-4.207-0.015626-8.2344-1.7109-11.191-4.707-2.9531-2.9961-4.5898-7.0469-4.543-11.254v-64.734zm-5.0391 344.57-344.62 0.003906c-4.1875 0-8.2031-1.6641-11.168-4.625-2.9609-2.9609-4.625-6.9766-4.625-11.168v-409.47c0-4.1914 1.6641-8.207 4.625-11.168 2.9648-2.9609 6.9805-4.625 11.168-4.625h244.38v80.527c0.015626 12.531 5 24.543 13.863 33.406 8.8594 8.8594 20.871 13.844 33.402 13.859h68.77v297.47c0 4.1914-1.6641 8.207-4.625 11.168-2.9648 2.9609-6.9805 4.625-11.168 4.625z"
  }), /*#__PURE__*/React.createElement("use", {
    x: 70,
    y: 644,
    xlinkHref: "#v"
  }), /*#__PURE__*/React.createElement("use", {
    x: 90.550781,
    y: 644,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    x: 104.359375,
    y: 644,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 123.347656,
    y: 644,
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("use", {
    x: 142.242188,
    y: 644,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    x: 155.628906,
    y: 644,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 174.617188,
    y: 644,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("use", {
    x: 204.410156,
    y: 644,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("use", {
    x: 224.453125,
    y: 644,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("use", {
    x: 252.453125,
    y: 644,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("use", {
    x: 274.148438,
    y: 644,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("use", {
    x: 292.402344,
    y: 644,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    x: 302,
    y: 644,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 330.734375,
    y: 644,
    xlinkHref: "#u"
  }), /*#__PURE__*/React.createElement("use", {
    x: 358.601562,
    y: 644,
    xlinkHref: "#t"
  }), /*#__PURE__*/React.createElement("use", {
    x: 368.195312,
    y: 644,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    x: 377.796875,
    y: 644,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    x: 387.390625,
    y: 644,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 406.382812,
    y: 644,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    x: 70,
    y: 672,
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("use", {
    x: 82.183594,
    y: 672,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    x: 95.992188,
    y: 672,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    x: 115.226562,
    y: 672,
    xlinkHref: "#r"
  }), /*#__PURE__*/React.createElement("use", {
    x: 154.152344,
    y: 672,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    x: 167.535156,
    y: 672,
    xlinkHref: "#q"
  }), /*#__PURE__*/React.createElement("use", {
    x: 187.46875,
    y: 672,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 216.207031,
    y: 672,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 239.640625,
    y: 672,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    x: 258.878906,
    y: 672,
    xlinkHref: "#o"
  }), /*#__PURE__*/React.createElement("use", {
    x: 278.8125,
    y: 672,
    xlinkHref: "#n"
  }), /*#__PURE__*/React.createElement("use", {
    x: 308.492188,
    y: 672,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("use", {
    x: 329.015625,
    y: 672,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    x: 342.820312,
    y: 672,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    x: 362.058594,
    y: 672,
    xlinkHref: "#l"
  }), /*#__PURE__*/React.createElement("use", {
    x: 371.65625,
    y: 672,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 390.648438,
    y: 672,
    xlinkHref: "#k"
  }), /*#__PURE__*/React.createElement("use", {
    x: 407.242188,
    y: 672,
    xlinkHref: "#c"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounPpt);
export default __webpack_public_path__ + "static/media/noun-ppt.bf375ab8a6063eb39efc91da30650105.svg";
export { ForwardRef as ReactComponent };